<template>
  <div
    v-if="loading"
    class="content"
  >
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div
    v-else
    class="content"
  >
    <div
      v-if="this.sites.length>0"
      class="md-layout"
    >
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card
          v-if="this.alarmList.length>0"
          data-background-color="red"
        >
          <template slot="header">
            <!-- <md-icon>starts</md-icon> -->
            <router-link to="/alarmList">
              <md-icon>notifications</md-icon>
            </router-link>
          </template>

          <template slot="content">
            <!-- <p class="category">Folowers</p> -->
            <h3 class="title">
              Alarmes
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              Alarmes ativos
            </div>
          </template>
        </stats-card>

        <stats-card
          v-else
          data-background-color="blue"
        >
          <template slot="header">
            <!-- <md-icon>starts</md-icon> -->
            <router-link to="/alarmList">
              <md-icon>notifications</md-icon>
            </router-link>
          </template>

          <template slot="content">
            <!-- <p class="category">Folowers</p> -->
            <h3 class="title">
              Alarmes
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              Alarmes ativos
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="blue">
          <template slot="header">
            <!-- <md-icon>starts</md-icon> -->
            <router-link to="/history">
              <md-icon>history</md-icon>
            </router-link>
          </template>

          <template slot="content">
            <!-- <p class="category">Folowers</p> -->
            <h3 class="title">
              Histórico
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              Eventos registrados pelo Online
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="blue">
          <template slot="header">
            <!-- <md-icon>starts</md-icon> -->
            <router-link to="/maps">
              <md-icon>map</md-icon>
            </router-link>
          </template>

          <template slot="content">
            <!-- <p class="category">Folowers</p> -->
            <h3 class="title">
              Mapa
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              Localizações dos Sites Monitorados
            </div>
          </template>
        </stats-card>
      </div>



      <div
        v-for="site in sites"
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card
          v-if="site.lastAlarmPriority>1"
          :data-background-color="site.lastAlarmPriority > 3 ? 'red': 'orange'"
        >
          <template slot="header">
            <!-- <md-icon>starts</md-icon> -->
            <router-link :to=" '/dashboard/' + site.entity">
              <img
                :src="site.location"
                style="width:76px; height:76px; "
              >
            </router-link>
          </template>


          <template slot="content">
            <h3 class="title">
              {{ site.site }}
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <drop-down :id="site.site">
                <a
                  slot="title"
                  class="dropdown-toggle"
                  data-toggle="dropdown-over"
                >
                  <md-icon class="text-danger">warning </md-icon>
                  {{ site.lastAlarm }}
                </a>

                </ul>
              </drop-down>
            </div>
          </template>
        </stats-card>

        <stats-card
          v-else
          data-background-color="blue"
        >
          <template slot="header">
            <!-- <md-icon>starts</md-icon> -->
            <router-link :to=" '/dashboard/' + site.entity">
              <img
                :src="site.location"
                style="width:76px; height:76px; "
              >
            </router-link>
          </template>

          <template slot="content">
            <!-- <p class="category">Folowers</p> -->
            <h3 class="title">
              {{ site.site }}
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              {{ site.lastAlarm }}
            </div>
          </template>
        </stats-card>
      </div>

      <new-ticket-button />
    </div>
    <div
      v-else
      class="md-layout"
    >
      <router-link
        to="https://www.green4t.com/solucoes/servicos-continuados"
        style="width:100% "
      >
        <img
          src="https://i.ibb.co/Nnf1Wrv/online-g4t.png"
          style="width:100% "
        >
      </router-link>
    </div>
  </div>
</template>

<script>
import { userService } from "../_services";
import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable
} from "@/components";
import NewTicketButton from "../components/NewTicketButton";
import { getUserSession } from "../_services/localstorage";

export default {
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable,
    NewTicketButton,
  },
  data() {
    return {
      loading:true,
      sites:[],
      oldSites:[],
      oldList: [],
      alarmList:[],
      glpiActiveEntity:0,
      emailsSubscriptionChart: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De"
          ],
          series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      }
    };
  },
  created() {

      this.loading = true;
      this.sites = JSON.parse(localStorage.getItem("sites"));
      this.loadData();
      this.timer = setInterval(this.loadData, 10000);
      this.checkSite();
      this.timer = setInterval(this.checkSite, 1000);
      this.timer = setInterval(this.checkOnlineSite, 1000);


  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    loadData: function () {

      if(this.sites.leght>0){
        userService.AsingZabbixProblems(this.sites).then(zabbixProblems => {
          this.oldList=this.alarmList;
          this.alarmList = zabbixProblems;
          // console.log(this.alarmList)
          // console.log(this.oldList)


          if(this.alarmList.length!=this.oldList.length){
            this.loading = true;
            var i=0,j=0,k=0,count=0;
            for(i=0;i<this.sites.length;i++){
              this.sites[i].lastAlarmPriority =  0;
              this.sites[j].alarmList=[];
            }

            for(i=0;i<this.alarmList.length;i++){

              for(j=0;j<this.sites.length;j++){
                if(this.sites[j].site==this.alarmList[i].site  && this.sites[j].lastAlarmPriority<this.alarmList[i].priority){

                  // this.sites[j].lastAlarm = this.alarmList[i].host.substring( this.alarmList[i].host.indexOf('_')+1, this.alarmList[i].host.length)+" - "+this.alarmList[i].application+" : "+this.alarmList[i].description;
                  this.sites[j].lastAlarm = "[ "+this.alarmList[i].host.substring( this.alarmList[i].host.indexOf("_")+1, this.alarmList[i].host.length)+" ] [ "+this.alarmList[i].application+" ] "+this.alarmList[i].item+" : "+this.alarmList[i].description;
                  this.sites[j].lastAlarmPriority =  this.alarmList[i].priority;
                  this.sites[j].alarmList.push(this.alarmList[i]);

                }
              }
            }



            this.sites=this.sites;
            this.loading = false;
          }
          //Solution when the alarmList is null
          if(this.alarmList.length==0){
            this.loading = false;
            for(j=0;j<this.sites.length;j++){
              this.sites[j].lastAlarmPriority =  0;
            }
          }


        });
      }
      else{this.loading = false;}


    },
    checkSite: function () {

      // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

      this.user = getUserSession();
      this.sites = JSON.parse(localStorage.getItem("sites"));
      // console.log(this.user);
      // this.totalTickets=this.totalTickets+1;

      if(this.user.activeentity!=this.glpiActiveEntity){
        this.loading=true;
        // console.log("Search1");
        this.loadData();
        this.glpiActiveEntity=this.user.activeentity;


      }









  },
  checkOnlineSites: function () {

    // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

    this.sites = JSON.parse(localStorage.getItem("sites"));
    // console.log(this.user);
    // this.totalTickets=this.totalTickets+1;

    if(this.sites.length!=this.oldSites.length){
      this.loading=true;
      // console.log("Search1");
      this.loadData();
      this.oldSites=this.sites;
    }

  },
    cancelAutoUpdate: function() { clearInterval(this.timer); }
  }
};
</script>
